<app-page-heading [title]="formTitle"></app-page-heading>

<section class="container-fluid summary-panel">
    <app-data-table [columns]="columns"
                    [sortColumn]="sortColumn"
                    [direction]="direction"
                    [loadPage]="loadPage"
                    [(filters)]="criteria"
                    (onLoad)="checkMaxUser($event)"
                    (onReset)="resetCriteria()"
                    [filtersComponent]="dataFilters"
                    [selectOnRowClick]="false"
                    [loadAtStartup]="false"
                    [loadOnReset]="false"
                    [cleanOnReset]="true">

        <app-data-filters #dataFilters
                          [fullWidth]="true"
                          [(opened)]="showFilters"
                          [disableSearch]="(!criteria.email || emailFilter.minLengthInvalid) && !criteria.carrierId">
            <app-data-filter-group class="main-group"
                                   [flexDirection]="'column'"
                                   [helperKey]="'user-dashboard.users.list.filters.helper-search'">
                <app-data-filter-group [useAvailableWidth]="true"
                                       [spaceAuto]="true"
                                       [spaceBetween]="true">
                        <app-data-filter-input
                            #emailFilter
                            [labelKey]="'user-dashboard.users.list.filters.email.label'"
                            [(model)]="criteria.email"
                            [minLength]="3"
                            [helperKey]="'user-dashboard.users.list.filters.email.helper'"
                            [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'">
                        </app-data-filter-input>

                        <app-data-filter-select [labelKey]="'user-dashboard.users.list.filters.carrier.label'"
                                                [emptyOption]="true"
                                                [emptyOptionKey]="'user-dashboard.users.list.filters.carrier.placeholder'"
                                                [(model)]="criteria.carrierId"
                                                [options]="carriersOptions"
                                                [useOptionLabel]="true"
                                                (modelChange)="onSelectedCarrier()">
                        </app-data-filter-select>
                        <app-data-buttons class="advancedSearch">
                            <a class="text-primary" (click)="showAdvancedSearch = !showAdvancedSearch">
                                <span [i18n]="'user-dashboard.users.list.filters.advanced-search'"></span>
                                <i class="fa"
                                [ngClass]="{'fa-chevron-down' : !showAdvancedSearch, 'fa-chevron-up' : showAdvancedSearch}"></i>
                            </a>
                        </app-data-buttons>
                </app-data-filter-group>

                <app-data-filter-group [useAvailableWidth]="true" *ngIf="showAdvancedSearch" class="m-t-sm">
                    <app-data-filter-select [labelKey]="'user-dashboard.users.list.filters.role.label'"
                                            [emptyOption]="true"
                                            [emptyOptionKey]="'user-dashboard.users.list.filters.role.placeholder'"
                                            [(model)]="criteria.role"
                                            [options]="rolesOptions"
                                            [useOptionLabel]="true">
                    </app-data-filter-select>

                    <app-data-filter-select [labelKey]="'user-dashboard.users.list.filters.subcontractor.label'"
                                            [emptyOption]="true"
                                            [emptyOptionKey]="'user-dashboard.users.list.filters.subcontractor.placeholder'"
                                            [disabled]="!criteria.carrierId"
                                            [(model)]="criteria.subcontractorId"
                                            [options]="subcontractorsOptions"
                                            [useOptionLabel]="true">
                    </app-data-filter-select>
                    <app-data-buttons class="advancedSearch"></app-data-buttons>
                </app-data-filter-group>
            </app-data-filter-group>
        </app-data-filters>

        <ng-container subBar>
            <i class="fa fa-warning text-danger" [i18n]="'user-dashboard.users.list.filters.max-number-search'" *ngIf="maxNumberUserSearch"></i>
        </ng-container>
    </app-data-table>
</section>

<ng-template #emailColumn let-email="email">
    {{email}}
</ng-template>

<ng-template #roleColumn let-roles="roles">
    <div *ngFor="let role of roles; let i=index">
        <ng-container *ngIf="i != roles.length-1 else lastRole">
            <span>{{role}},&nbsp;</span>
        </ng-container>
        <ng-template #lastRole>
            <span>{{role}}</span>
        </ng-template>
    </div>
</ng-template>

<ng-template #carrierColumn let-carrierId="carrierId" let-carrierName="carrierName" let-roles="roles">
    <ng-container *ngIf="carrierName else noCarrier">
        <a [routerLink]="gotoCarrierPage(carrierId, roles)" target="_blank">
            {{carrierName}}
        </a>
    </ng-container>
    <ng-template #noCarrier>
        <span [i18n]="'user-dashboard.users.list.filters.no-carrier'"></span>
    </ng-template>
</ng-template>

<ng-template #subcontractorColumn let-carrierId="carrierId" let-subcontractorName="subcontractorName">
    <ng-container *ngIf="subcontractorName else noSubcontractor">
        <a [routerLink]="gotoSubcontractorPage(carrierId)">
            {{subcontractorName}}
        </a>
    </ng-container>
    <ng-template #noSubcontractor>
        <span [i18n]="'user-dashboard.users.list.filters.no-subcontractor'"></span>
    </ng-template>
</ng-template>

<ng-template #statusColumn let-blocked="blocked">
    <span *ngIf="!blocked" class="fa fa-unlock text-success" [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.not-blocked'}]"></span>
    <span *ngIf="blocked" class="fa fa-lock text-danger" [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.blocked'}]"></span>
</ng-template>
